<div class="title p-2">
	<div class="row">
		<div class="col d-flex justify-content-start">
			<h1 class="mx-1">Încarcă document semnat digital</h1>

		</div>
		<div class="col d-flex justify-content-end">
			<button type="button" class="action-btn" (click)="closeDialog()">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
</div>


<div class="container p-2">
	<div class="row">
		<div class="col">
			<form [formGroup]="validateDocumentForm" (ngSubmit)="submitDocumentSwitch()">
				<div class="row">
					<div class="col">
						<div class="solicitare-card__upload">
							<div class="solicitare-card__upload-header">
								<p class="upload-text">
									<span *ngIf="data.doc_type !== 2">Fotografii/Documente</span>
									<span *ngIf="data.doc_type == 2">Încărcare exemplar Semnatari</span>

								</p>
								<button class="upload-btn" (click)="fileInput.click()" type="button">
									<mat-icon class="upload-icon">cloud_upload</mat-icon>
									ÎNCARCĂ
								</button>
							</div>

							<div class="solicitare-card__upload-files"
								*ngIf="validateDocumentForm.get('file')?.value && !uploading.file">
								<div class="solicitare-card__upload-file">
									<span class="solicitare-card__upload-file-name">
										{{ (validateDocumentForm.get('file')?.value.original_name.length > 30) ?
										(validateDocumentForm.get('file')?.value.original_name | slice: 0:30) + '..' :
										(validateDocumentForm.get('file')?.value.original_name) }}
									</span>
									<div>
										<button class="solicitare-card__upload-file-delete" type="button"
											matTooltip="Șterge fișierul încărcat" (click)="removeFile()">
											<img class="btn-img" src="assets/icons/delete.svg" alt="" />
										</button>
									</div>
								</div>
							</div>

							<mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
								*ngIf="uploading.file"></mat-spinner>

							<input type="file" accept="application/pdf" id="upload-file-input-0" #fileInput
								name="fileInput" (change)="addFile($event)" style="display: none">
						</div>

					</div>
				</div>

                <div class="row my-3" *ngIf="data.doc_type == 2">
                    <div class="col">
                        <div class="solicitare-card__upload">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">Încărcare exemplar Cetățean</p>
                                <button class="upload-btn" (click)="fileInputCetatean.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>

                            <div class="solicitare-card__upload-files"
                                *ngIf="validateDocumentForm.get('exemplarCetatean')?.value && !uploading.file">
                                <div class="solicitare-card__upload-file">
                                    <span class="solicitare-card__upload-file-name">
                                        {{ (validateDocumentForm.get('exemplarCetatean')?.value.original_name.length > 30) ?
                                        (validateDocumentForm.get('exemplarCetatean')?.value.original_name | slice: 0:30) + '..' :
                                        (validateDocumentForm.get('exemplarCetatean')?.value.original_name) }}
                                    </span>
                                    <div>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat" (click)="removeFileCetatean()">
                                            <img class="btn-img" src="assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="isExemplarLoading"></mat-spinner>

                            <input type="file" accept="application/pdf" id="upload-file-input-0" #fileInputCetatean
                                name="fileInputCetatean" (change)="addFileCetatean($event)" style="display: none">
                        </div>
                    </div>
                </div>

				<div class="row my-3" *ngIf="data.type == 3">
					<div class="col">
						<div class="solicitare-card__upload">
							<div class="solicitare-card__upload-header">
								<p class="upload-text">Anexe oficiale</p>
								<button class="upload-btn" (click)="fileInputRegistru.click()" type="button">
									<mat-icon class="upload-icon">cloud_upload</mat-icon>
									ÎNCARCĂ
								</button>
							</div>
							<div class="solicitare-card__upload-files" *ngIf="
                            validateDocumentForm.value.anexe.length > 0 &&
                                !isAnexeLoading">
								<div class="solicitare-card__upload-file" *ngFor="
                                    let uploadedFile of validateDocumentForm.value.anexe;
                                    let i = index
                                ">
									<span class="solicitare-card__upload-file-name">
										{{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name
										| slice : 0 : 30) + ".." : uploadedFile.original_name
										}}
									</span>
									<div>
										<button class="solicitare-card__upload-file-delete" type="button"
											matTooltip="Șterge fișierul încărcat" (click)="removeFileRegistru(i)">
											<img class="btn-img" src="/assets/icons/delete.svg" alt="" />
										</button>
									</div>
								</div>
							</div>
							<mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
								*ngIf="isAnexeLoading"></mat-spinner>

							<input type="file" accept="application/pdf" id="upload-file-input-0" #fileInputRegistru
								name="fileInputRegistru" (change)="addFilesRegistru($event, 'registruFile')" multiple
								style="display: none" />
						</div>
					</div>
				</div>

				<div class="row mt-4">
					<div class="col">
						<div class="d-flex justify-content-end">
							<button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
								{{ helper.dialogConfig.buttonLabels.close }}
							</button>
							<button class="buttons" mat-flat-button color="primary" type="submit"
								[disabled]="validateDocumentForm.invalid">
								{{ helper.dialogConfig.buttonLabels.save }}
							</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="section-spinner position-absolute" *ngIf="isLoading">
	<div class="spinner position-absolute top-50 start-50 translate-middle">
		<mat-spinner></mat-spinner>
		<h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
	</div>
</div>